module.exports = __webpack_public_path__ + "img/abbc.e1daed38.svg";